import { useState, useEffect } from "react";
import { Plus, ArrowLeft } from "lucide-react";
import { sigteApiFetch, sigteApiFetchChecked } from "./sigteUtils";
import { Campo } from "./SigteFormField";

var BLANK = {nombre:"",rfc:"",direccion:"",contacto:"",correo:"",telefono:"",contrato:""};

// Rediseno Bloque 3: sigte-prototipo.jsx:648-798 (Clientes). El prototipo
// tiene lista -> detalle -> formulario (3 estados); aqui se queda en lista ->
// formulario (2 estados) porque al abrir un cliente ya navegamos directo a
// Edificios (onOpenCliente) -- no se agrega una pagina de detalle nueva, eso
// seria funcional, no visual. Confirmacion de borrado: inline por fila, como
// el prototipo (ya no <ConfirmModal>).
export function SigteClientes(p) {
  var [clientes,setClientes]=useState([]);
  var [loading,setLoading]=useState(true);
  var [view,setView]=useState("list");
  var [editing,setEditing]=useState(null);
  var [form,setForm]=useState(BLANK);
  var [err,setErr]=useState("");
  var [confirmDeleteId,setConfirmDeleteId]=useState(null);

  function load(){
    sigteApiFetch("/clientes").then(function(r){return r.json();}).then(function(d){
      setClientes(d.clientes||[]); setLoading(false);
    });
  }
  useEffect(load,[]);

  function setF(k,v){ setForm(function(f){return Object.assign({},f,{[k]:v});}); }

  function startNew(){ setEditing(null); setForm(BLANK); setErr(""); setView("edit"); }
  function startEdit(c){ setEditing(c); setForm(Object.assign({},BLANK,c)); setErr(""); setView("edit"); }

  async function save(){
    if(!form.nombre.trim()){setErr("El nombre es requerido.");return;}
    var path = editing ? "/clientes/"+editing.id : "/clientes";
    var method = editing ? "PUT" : "POST";
    try {
      await sigteApiFetchChecked(path,{method:method,body:JSON.stringify(form)});
      setView("list"); load();
    } catch(e) {
      setErr(e.message);
    }
  }

  async function del(c){
    try {
      await sigteApiFetchChecked("/clientes/"+c.id,{method:"DELETE"});
      setConfirmDeleteId(null); load();
    } catch(e) {
      setErr(e.message); setConfirmDeleteId(null);
    }
  }

  if(loading) return <p className="text-sm text-neutral-500">Cargando...</p>;

  if(view==="edit"){
    return (
      <div className="space-y-6">
        <button onClick={function(){setView("list");}} className="inline-flex items-center gap-1 text-sm font-medium text-neutral-500 hover:text-neutral-900">
          <ArrowLeft size={16}/> Cancelar
        </button>
        <h1 className="text-2xl font-semibold tracking-tight text-neutral-900">{editing?"Editar cliente":"Nuevo cliente"}</h1>
        <div className="rounded-2xl border border-neutral-200 bg-white p-5">
          {err?<div className="mb-4 rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700">{err}</div>:null}
          <div className="grid gap-3 sm:grid-cols-2">
            <Campo label="Nombre del cliente" value={form.nombre} onChange={function(v){setF("nombre",v);}} placeholder="Razón social" className="sm:col-span-2"/>
            <Campo label="RFC" value={form.rfc} onChange={function(v){setF("rfc",v);}} placeholder="XXXX000000XX0"/>
            <Campo label="Contacto" value={form.contacto} onChange={function(v){setF("contacto",v);}} placeholder="Nombre del contacto"/>
            <Campo label="Correo" value={form.correo} onChange={function(v){setF("correo",v);}} placeholder="correo@cliente.mx"/>
            <Campo label="Teléfono" value={form.telefono} onChange={function(v){setF("telefono",v);}} placeholder="33 0000 0000"/>
            <Campo label="Contrato" value={form.contrato} onChange={function(v){setF("contrato",v);}} placeholder="Folio · vigencia" className="sm:col-span-2"/>
            <Campo label="Dirección" value={form.direccion} onChange={function(v){setF("direccion",v);}} placeholder="Calle, número, ciudad" className="sm:col-span-2"/>
          </div>
          <button onClick={save} disabled={!form.nombre.trim()}
            className="mt-5 w-full rounded-xl bg-neutral-900 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-neutral-700 disabled:opacity-30 sm:w-auto">
            Guardar cliente
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-neutral-900">Clientes</h1>
          <p className="mt-1 text-sm text-neutral-500">{clientes.length+" clientes"}</p>
        </div>
        <button onClick={startNew} className="inline-flex items-center gap-1.5 rounded-xl bg-neutral-900 px-3.5 py-2 text-sm font-medium text-white transition-colors hover:bg-neutral-700">
          <Plus size={16}/> Nuevo cliente
        </button>
      </header>
      {err?<div className="rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700">{err}</div>:null}
      <div className="overflow-hidden rounded-2xl border border-neutral-200 bg-white">
        {clientes.map(function(c,i){
          return (
            <div key={c.id} className={"flex flex-wrap items-center justify-between gap-3 px-5 py-4 " + (i>0 ? "border-t border-neutral-100" : "")}>
              <button onClick={function(){p.onOpenCliente(c);}} className="min-w-0 flex-1 text-left">
                <p className="truncate text-sm font-medium text-neutral-900">{c.nombre}</p>
                <p className="mt-0.5 text-xs text-neutral-500">{(c.rfc||"Sin RFC")+" · "+(c.contacto||"Sin contacto")}</p>
              </button>
              <div className="flex flex-wrap items-center gap-2">
                <button onClick={function(){p.onOpenCliente(c);}} className="rounded-xl border border-neutral-200 px-3.5 py-2 text-sm font-medium text-neutral-700 transition-colors hover:border-neutral-400">Ver edificios</button>
                <button onClick={function(){startEdit(c);}} className="rounded-xl border border-neutral-200 px-3.5 py-2 text-sm font-medium text-neutral-700 transition-colors hover:border-neutral-400">Editar</button>
                {confirmDeleteId===c.id ? (
                  <div className="flex items-center gap-2 rounded-xl bg-red-50 px-3 py-2">
                    <span className="text-xs text-red-700">¿Eliminar?</span>
                    <button onClick={function(){del(c);}} className="text-xs font-medium text-red-700 underline">Sí</button>
                    <button onClick={function(){setConfirmDeleteId(null);}} className="text-xs font-medium text-neutral-500">No</button>
                  </div>
                ):(
                  <button onClick={function(){setConfirmDeleteId(c.id);}} className="rounded-xl border border-red-200 px-3.5 py-2 text-sm font-medium text-red-600 transition-colors hover:bg-red-50">Eliminar</button>
                )}
              </div>
            </div>
          );
        })}
        {clientes.length===0?<p className="px-5 py-8 text-center text-sm text-neutral-400">No hay clientes registrados.</p>:null}
      </div>
    </div>
  );
}
